export default __webpack_public_path__ + "static/media/recorte_16.ad0bcb7a.JPG";